/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeleteUbiThirdpartyAgreementsCommand = {
  /**
   * Vehicle Identification Number (VIN)
   */
  vin: string;
  /**
   * 보험사 서비스 아이디
   */
  serviceId: string;
  /**
   * 생년월일 (YYYYMMDD 형식)
   */
  birthDd?: string;
  /**
   * 고객 타입(1:개인, 2:법인 3: 외국인, 4: 개인사업자, 5: 공공기관 (Ccs Portal /getUbiSuptInfo 규격서 에서는 3:외국인, 4: 개인사업자로 구성 현재 3,4에 대한 별도 분기처리는 없어 정상동작함))
   */
  customerType?: DeleteUbiThirdpartyAgreementsCommand.customerType;
  /**
   * 동의 정보 타입(1: SAFE_DRIVING_SCORE (안전운전점수) , 2: CONNECTED_SERVICES (커넥티드 서비스 가입 정보) , 3: TOTAL_DISTANCE_TRAVELED(누적 주행 거리)
   * 복수개 선택 가능하며, array 형태로 입력합니다.
   */
  agreeInfo: Array<'1' | '2' | '3'>;
  /**
   * 법인번호(법인 차량인 경우, 필수 입력)
   */
  corpRgstNo?: string;
  /**
   * 사업자번호(법인 차량인 경우, 필수 입력)
   */
  taxId?: string;
};
export namespace DeleteUbiThirdpartyAgreementsCommand {
  /**
   * 고객 타입(1:개인, 2:법인 3: 외국인, 4: 개인사업자, 5: 공공기관 (Ccs Portal /getUbiSuptInfo 규격서 에서는 3:외국인, 4: 개인사업자로 구성 현재 3,4에 대한 별도 분기처리는 없어 정상동작함))
   */
  export enum customerType {
    _1 = '1',
    _2 = '2',
    _3 = '3',
    _4 = '4',
    _5 = '5',
  }
}

